import React from 'react';
import classNames from '@/lib/class-names';

const HtmlContentContainerDefaultElement = 'div';

interface HtmlContentContainer {
  <E extends React.ElementType = typeof HtmlContentContainerDefaultElement>(
    props: HtmlContentContainerProps<E>,
  ): React.ReactElement;
  displayName: string;
}

type HtmlContentContainerProps<E extends React.ElementType> = HtmlContentContainerOwnProps<E> &
  Omit<React.ComponentProps<E>, keyof HtmlContentContainerOwnProps>;

type HtmlContentContainerOwnProps<E extends React.ElementType = React.ElementType> = {
  applyDefaultClassName?: boolean;
  as?: E;
  className?: string;
  html: string;
};

const HtmlContentContainer: HtmlContentContainer = ({
  applyDefaultClassName = true,
  as: Component = HtmlContentContainerDefaultElement,
  className,
  html,
  ...rest
}) => (
  <Component
    className={classNames(applyDefaultClassName && 'html-content-container', className)}
    {...rest}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

HtmlContentContainer.displayName = 'HtmlContentContainer';

export default HtmlContentContainer;
